export function importAll(r) {
	let files = {}
	r.keys().map((item) => {
		// key is filename without extension
		let key = item.replace('./', '').split("/");
		key = key[key.length-1].split('.')[0];
		files[key] = r(item)
	})
	return files
}

export function importImages(r) {
	let files = {
		img: {},
		json: {}
	}
	r.keys().map((item) => {
		// key is filename without extension
		// files.push(r(item))
		let key = item.replace('./', '').split("/");
		key = key[key.length-1].split('.')[0];
		if (item.includes(".png")) {
			files.img[key] = r(item)
		} else if (item.includes(".json")) {
			files.json[key] = r(item)
		} else {
			console.warn("unknown asset sprite type")
		}
	})
	return files
}